export default __webpack_public_path__ + "static/media/DefaultIndustryAvatar.378cbcfa.svg";